import { CoreType, PlanetCardBackground } from '@apeiron/planet'
import {
  DEFAULT_ANIMATE_DURATION,
  MayNull,
  NextImage,
  noForwardCustomProps,
  noForwardProps
} from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import ArcanePNG from '@public/images/background-planet-card-arcane.png'
import DivinePNG from '@public/images/background-planet-card-divine.png'
import ElementalPNG from '@public/images/background-planet-card-elemental.png'
import MythicPNG from '@public/images/background-planet-card-mythic.png'
import NormalPNG from '@public/images/background-planet-card-normal.png'
import NormalHoverPNG from '@public/images/background-planet-card-normal-hover.png'
import PrimalPNG from '@public/images/background-planet-card-primal.png'
import { CLASS_NAMES } from '@src/components/planet/share/planetCard/classes'
import * as R from 'ramda'
import { FC } from 'react'

const PlanetCartdBackgroundMap = {
  [CoreType.Primal]: {
    normal: PrimalPNG.src,
    hover: PrimalPNG.src
  },
  [CoreType.Divine]: {
    normal: DivinePNG.src,
    hover: DivinePNG.src
  },
  [CoreType.Arcane]: {
    normal: ArcanePNG.src,
    hover: ArcanePNG.src
  },
  [CoreType.Mythic]: {
    normal: MythicPNG.src,
    hover: MythicPNG.src
  },
  [CoreType.Elemental]: {
    normal: ElementalPNG.src,
    hover: ElementalPNG.src
  },
  [CoreType.Normal]: {
    normal: NormalPNG.src,
    hover: NormalHoverPNG.src
  },
  [CoreType.None]: {
    normal: NormalPNG.src,
    hover: NormalHoverPNG.src
  }
}

const Container = styled(Box, noForwardProps)<ContainerProps>`
  aspect-ratio: 0.649;
  background-position: 5% 0px;
  background-size: cover;
  position: relative;
  pointer-events: none;
  transition: background-image ${DEFAULT_ANIMATE_DURATION}ms;
  ${props =>
    props.__background
      ? `background-image: url(${props.__background.normal});`
      : ''}
  :hover {
    ${props =>
      props.__background
        ? `background-image: url(${props.__background.hover});`
        : ''}
  }
`

const ElementIcon = styled(NextImage)`
  position: absolute;
  top: -5%;
  left: -4%;
  width: 22%;
  height: 22%;
`

const PlanetImage = styled(
  NextImage,
  noForwardCustomProps(['disabled'])
)<PlanetImageProps>`
  position: absolute;
  top: -6.5%;
  left: -9.3%;
  width: 117%;
  height: 117%;
  ${props =>
    props.disabled
      ? 'filter: contrast(135%) saturate(40%) sepia(15%) brightness(0.65) !important;'
      : ''}
`

const PlanetCardImage: FC<Props> = (props: Props) => {
  const { className, coreType, disabled = false, iconURL, imageURL } = props

  const background = PlanetCartdBackgroundMap[coreType]

  return (
    <Container __background={background} className={className}>
      {!R.isNil(iconURL) && (
        <ElementIcon className={CLASS_NAMES.icon} src={iconURL} />
      )}
      <PlanetImage
        className={CLASS_NAMES.planet}
        disabled={disabled}
        src={imageURL}
      />
    </Container>
  )
}

type ContainerProps = {
  __background: MayNull<PlanetCardBackground>
}

type PlanetImageProps = {
  disabled: boolean
}

type Props = {
  className?: string
  coreType: CoreType
  disabled?: boolean
  iconURL?: string
  imageURL: string
}

export default PlanetCardImage
